import React from 'react';
import Container from '@material-ui/core/Container';
import styled from 'styled-components';
import { useMediaQuery } from '@material-ui/core';
import { BREAKPOINTS } from 'src/utils/constants';
import SearchForm from '../forms/SearchForm';

const BannerContainer = styled.div`
  width: 100%;
  position: relative;
  background: rgba(54, 59, 77, 0.88) url('/assets/background/bg-1.webp') fixed;
  background-size: cover;
  padding: ${({ isMobile }) => (isMobile && '50px 0px') || '50px'};
`;
const BannerContent = styled.div`
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SearchPageBanner = () => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  return (
    <BannerContainer isMobile={isMobile}>
      <Container maxWidth="lg">
        <BannerContent>
          <SearchForm />
        </BannerContent>
      </Container>
    </BannerContainer>
  );
};
export default SearchPageBanner;
